import { authGetters } from "@/state/helpers";

export default {
  computed: {
    ...authGetters,
  },
};
